import { css } from 'styled-components';

const rounded = css`
  ${({ rounded }) => rounded && 'border-radius: 1rem;'}

  ${({ roundedCircle }) => roundedCircle && 'border-radius: 50%;'}
`;

export default rounded;
